import { app } from '../../../app';
import { Controller } from './landing-page.controller';

app.component('companyLandingPage', {
    bindings: {
        currentCompany: '<',
        reg: '<',
        licenseInfo: '<',
    },
    controller: Controller,
    templateUrl: require('./landing-page.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/landing-page/landing-page.component.js